import { sendDelete, sendGet, sendPost } from "./generic"

export const getGaiUsersByPagination = ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Admin/GaiUsers/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const searchGaiUsersByPagination = ({
    searchTerm,
    searchIn,
    pageIndex,
    numberOfRecords,
    orderBy,
    descending
}) => {
    return sendGet(`Admin/GaiUsers/${searchTerm}/${searchIn}/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const addGaiUser = (payload) => {
    return sendPost(`Admin/GaiUsers`, payload)
}

export const editGaiUser = (payload) => {
    return sendPost(`Admin/GaiUsers`, payload)
}

export const deleteGaiUser = (id) => {
    return sendDelete(`Admin/GaiUsers/${id}`)
}

export const inviteUser = (id) => {
    return sendGet(`Admin/GaiUsers/${id}/Invite`)
}

export const getGaiUserByID = (id) => {
    return sendGet(`Admin/GaiUsers/${id}`)
}
